// extracted by mini-css-extract-plugin
module.exports = {"root":"root__3YaX6weqZAE4","labels":"labels__2rQpg8eqUheK"};